<template>
  <div class="df-container df-alert" v-if="value">
    <div class="mask"></div>
    <div class="df-main alert">
      <div class="container">
        <div class="title">{{info.title}}</div>
        <div class="content">
          <div class="label" v-if="info.carArr.length > 0">
            <div class="tit">车辆</div>
            <div class="list">
              <div class="item car" v-for="(item,index) in info.carArr" :key="index">{{item}}</div>
            </div>
          </div>
          <div class="label" v-if="info.shopArr.length > 0">
            <div class="tit">门店</div>
            <div class="list">
              <div class="item" v-for="(item,index) in info.shopArr" :key="index">{{item}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="button" @click="close()">{{info.buttonText}}</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'alertLabel',
    data:function () {
      return {

      }
    },
    props: [
      'value',
      'info',
    ],
    created () {

    },
    mounted(){

    },
    watch:{

    },
    methods: {
      close(){
        this.$emit("on-hide");
      }
    },
  }
</script>

<style lang="scss" scoped type="text/scss">
  @import "css/common";
  .df-main{
    .content{
      flex-direction: column;
      .label{
        margin-bottom: 10px;
        .tit{
          font-size: 28px;
        }
        .list{
          box-sizing: border-box;
          display: flex;
          flex-flow:wrap;
          margin-top: 10px;
          .item{
            display: inline-block;
            margin-top: 20px;
            margin-right: 10px;
            font-size: 24px;
            border: 1px solid #929292; /*no*/
            border-radius:24px;
            padding: 5px 14px;
            color: #929292;
            /*&.car:first-of-type{*/
              /*border: 2px solid #1ccfc9;*/
              /*color: #1ccfc9;*/
            /*}*/
          }
          .itemcolor{
            display: inline-block;
            margin-top: 20px;
            margin-right: 10px;
            font-size: 24px;
            border: 1px solid #1ccfc9; /*no*/
            border-radius:24px;
            padding: 5px 14px;
            color: #1ccfc9;
          }
        }
      }
    }
    .button{
      display: flex;
      justify-content: center;
      padding: 30px;
      box-sizing: border-box;
      color: $mainColor;
      font-size: 30px;
    }
  }


</style>
